/*
 * @Author: wilson 1207014631@qq.com
 * @Date: 2023-09-19 12:34:47
 * @LastEditors: wilson 1207014631@qq.com
 * @LastEditTime: 2023-09-20 11:01:50
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    redirect: "/home",
    children: [
      {
        path: 'home',
        name: 'home', //首页
        component: () => import('@/views/HomeView.vue')
      },
      {
        path: "aboutUs",
        name: "aboutUs",//关于我们
        component: () => import("@/views/aboutUs.vue"),
      },
      {
        path: "products/:id",
        name: "products", //产品中心
        component: () => import("@/views/products.vue"),
      },
      {
        path: "solution",
        name: "solution", //解决方案
        component: () => import("@/views/solution.vue"),
      },
      {
        path: "cases",
        name: "cases", //案例展示
        component: () => import("@/views/cases.vue"),
      },
      {
        path: "support",
        name: "support", //客户服务
        component: () => import("@/views/support.vue"),
      },
      {
        path: "joinUs",
        name: "joinUs", //加入我们
        component: () => import("@/views/joinUs.vue"),
    },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
